import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Card, Button, Image, Spinner, Alert } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { loggedUser } from "../../../redux/authSlice";
import userImg from "../../../images/user.png";
import { toast } from "react-toastify";

const ProfileRow = ({ label, value }) => (
  <Row className="mb-3">
    <Col xs={4}><strong>{label}:</strong></Col>
    <Col>{value || <span className="text-muted">- not added -</span>}</Col>
  </Row>
);

const Profile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user = {}, error, loading } = useSelector((state) => state.auth || {});
  if (process.env.NODE_ENV === "development") {
    console.log("user++++", user, error, loading);
  }
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      dispatch(loggedUser(token)).catch((err) => toast.error(err.message));
    }
  }, [dispatch]);

  if (loading) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center vh-100">
        <Spinner animation="border" />
        <p className="mt-3">Loading your profile...</p>
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="danger" className="text-center mt-3">
        {error}
      </Alert>
    );
  }

  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col md={4}>
          <Card className="p-3 shadow-sm">
            <Link to="/my/profile" className="text-decoration-none">Profile</Link>
            <Link to="/my/order" className="text-decoration-none">Order</Link>
          </Card>
        </Col>
        <Col md={8}>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title className="text-center mb-4">Profile Information</Card.Title>

              <ProfileRow label="Full Name" value={user?.name} />
              <ProfileRow
                label="Profile Picture"
                value={<Image src={user?.profilePicture || userImg} alt="Profile" width={50} height={50} />}
              />
              <ProfileRow label="Mobile Number" value={user?.whatsappNumber} />
              <ProfileRow
                label="Email ID"
                value={
                  user?.isVerified ? (
                    <span className="badge bg-success">Verified</span>
                  ) : (
                    <span className="badge bg-danger">Unverified - <Link to="/verify-email">Verify Now</Link></span>
                  )
                }
              />
              <ProfileRow label="Gender" value="Male" />
              <ProfileRow label="Date of Birth" value={user?.dob} />
              <ProfileRow label="Location" value={user?.location} />
              <ProfileRow label="Home Address" value={user?.homeAddress} />
              <ProfileRow label="Office Address" value={user?.officeAddress} />
              <ProfileRow label="Alternate Mobile" value={user?.alternateMobile} />
              <ProfileRow label="Hint Name" value={user?.hintName} />

              <div className="text-center mt-3">
                <Button variant="primary" onClick={() => navigate("/my/profile/edit")}>
                  Edit Profile
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Profile;
